import { render, staticRenderFns } from "./wallet-view-page.vue?vue&type=template&id=5a75f61e&scoped=true&"
import script from "./wallet-view-page.vue?vue&type=script&lang=js&"
export * from "./wallet-view-page.vue?vue&type=script&lang=js&"
import style0 from "./wallet-view-page.vue?vue&type=style&index=0&id=5a75f61e&scoped=true&lang=css&"
import style1 from "./wallet-view-page.vue?vue&type=style&index=1&id=5a75f61e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a75f61e",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl})
